import Instance from "../../../Axios";

const GetPlusTipoDocs = () => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/data/tipoDocs`)
    .then(({ data }) => {
      dispatch({ type: "GET_PLUS_TIPO_DOCS", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPlusTipoDocs;
